import React from 'react';
import styles from './MapPointer.less';

type MapPointerProps = {
  lat: number;
  lng: number;
  title?: string;
};

const MapPointer: React.SFC<MapPointerProps> = ({ title }): JSX.Element => (
  <svg className={styles.pointer} viewBox="0 0 21 29" fill="none">
    {title && <title>{title}</title>}
    <path
      d="M19.9203 9.94318C19.9203 17.8977 8.96414 28.3381 9.96016 28.3381C10.9562 28.3381 0 17.8977 0 9.44602C0 3.95456 4.45931 0 9.96016 0C15.461 0 19.9203 4.45171 19.9203 9.94318Z"
      transform="translate(0.561646)"
      fill="url(#paint0_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x2="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(19.9203) scale(19.9203 28.3381) rotate(90)"
      >
        <stop stopColor="#1C94BC" />
        <stop offset="1" stopColor="#227697" />
      </linearGradient>
    </defs>
  </svg>
);

export default MapPointer;
